import { useTranslation } from "react-i18next";
import ContainerLayout from "../../../components/container-layout/ContainerLayout";
import StateComponents from "../../../components/state-component/StateComponents";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import StepperCustom from "../../../components/step/Stepper";
import { useEffect, useRef, useState } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import ContainerButton from "../../../components/button/ContainerButton";
import { useNavigate, useParams } from "react-router-dom";
import { AdmissionFrontApi } from "../../../api/admission-front/admission-front.api";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useDispatch, useSelector } from "react-redux";
import { alertActive, alertError, alertSuccess, swalError } from "../../../components/alert/swal";
import { AdmissionAdminApi } from "../../../api/admission_admin/admission_admin.api";
import { timeToView } from "../../../utils/date.utils";
import ModalCustom from "../../../components/modal/ModalCustom";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import { ADMISSION_STATUS } from "../history-online-Admission/enum/admission.enum";
import { getFileExtension } from "../../../utils/fileTypeDownload";
import saveAs from "file-saver";
import { ButtonContained } from "../../../components/button/ButtonCustoms";
import { RootState } from "../../../store/store";
import { checkPermission, permission_config } from "../../../utils/app.utils";

export default function ApplicentDetail() {
  const profile = useSelector((state: RootState) => state.profile.profile) as any;
  const permission: any[] = profile?.permission || [];
  const checkPermit: permission_config = checkPermission("LIST_APPLICANTS", permission)
  const { t } = useTranslation();
  const { id } = useParams()
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const fileRef = useRef<any>()
  const [file, setFile] = useState<any>();

  const [form, setForm] = useState<any>();
  const [tabStep, setTebStep] = useState(0);
  const [showModal, setShowModal] = useState<string>("");
  const [des, setDes] = useState<any>('')

  const handleCloseModal = () => {
    setShowModal("");
    setDes('')
    setFile(null)
    if (fileRef.current) {
      fileRef.current.value = null;
    }
  }
  const allStep = [
    {
      name: t("LIST_APPLICANTS_PERSONAL_INFO"),
      isAccept: false,
      icon: null
    },
    {
      name: t("LIST_APPLICANTS_PAYMENT_PROOF"),
      isAccept: false,
      icon: null
    },

  ];

  const getDetail = async () => {
    dispatch(setLoading());

    await AdmissionFrontApi.findOne(id).then((res) => {
      if (res.status < 300) {
        setForm(res.data.data)
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      dispatch(unsetLoading());
    })
  }
  useEffect(() => {
    getDetail()
  }, [])

  // const handleVerified = async () => {
  //   dispatch(setLoading());
  //   if (id) {
  //     await AdmissionAdminApi.verified(+id)
  //       .then((res) => {
  //         if (res.status < 300) {
  //           alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => {
  //             navigate(routeName.admission.list_applicants)

  //           });
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         swalError(err?.response?.data?.message || t('LIST_APPLICANTS_ERROR'))
  //       })
  //       .finally(() => {
  //         dispatch(unsetLoading());
  //       });
  //   }
  // }
  const handleAPPROVE = async () => {
    const formData = new FormData();

    //DRAFT
    formData.append('file', file);
    formData.append('id_admission_student_register_payment ', `${form?.admission_student_register_payment?.id_admission_student_register_payment}`);
    dispatch(setLoading());
    if (id) {
      await AdmissionAdminApi.successPaymentRegister(id, formData)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess("อนุมัติการตรวจสอบ", "อนุมัติการตรวจสอบ เรียบร้อย");
            if (fileRef.current) {
              fileRef.current.value = null;
            }
            navigate(routeName.admission.list_applicants)
          }
        })
        .catch((err) => {
          console.log(err);
          alertError("อนุมัติการตรวจสอบ", "อนุมัติการตรวจสอบ ไม่สำเร็จ");
          if (fileRef.current) {
            fileRef.current.value = null;
          }
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    }
  }
  const handleReject = async () => {
    const body = {
      admission_status_remark: des
    }
    dispatch(setLoading());
    if (id) {
      await AdmissionAdminApi.rejected(+id, body)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.admission.list_applicants));
          }
        })
        .catch((err) => {
          console.log(err);
          swalError(err?.response?.data?.message || t('LIST_APPLICANTS_ERROR'))
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    }
  }
  function formatBytes(bytes: any, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }
  return (
    <div className='w-full'>
      <ContainerLayout
        title={t("LIST_APPLICANTS_PERSONAL_INFO")}
        // hidden_sub_title
        navigateContent={
          <NavigateListCustom
            navigateData={[
              {
                key: "complaintSubmit",
                name: t("LIST_APPLICANTS_LIST"),
                disabled_match: true,
                pathName: routeName.admission.list_applicants
              },
              {
                key: "complaintSubmit",
                name: t("LIST_APPLICANTS_IBSC_ONLINE_ADMISSION"),
                pathName: routeName.admission.list_applicants
              },
              {
                key: "complaintSubmit",
                name: t("LIST_APPLICANTS_PERSONAL_INFO"),
                pathName: routeName.admission.list_applicants
              },
            ]}
          />
        }
        buttonContent={
          // <ContainerButton
          //     justifyContent='flex-end'
          //     buttonData={[
          //         {
          //             buttonProps: {
          //                 onClick: handleDownloadReport
          //             },
          //             key: "DOWNLOAD_CSV",
          //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
          //             seq: 1,
          //             type: "DOWNLOAD_CSV"
          //         }
          //     ]}
          // />
          <></>
        }
        content={
          <div className='w-full'>
            <section
              style={{
                display: "flex",
                justifyContent: "start",
                marginTop: "24px",
              }}
            >
              <StepperCustom
                step={tabStep}
                setStep={setTebStep}
                stepLabel={allStep}
                view={true}
                mode={'normal'}
              />
            </section>
            {tabStep === 0 &&
              <div style={{ display: 'flex', flexDirection: 'column', gap: "20px" }}>
                <FormApplicant form={form} />
                <FileApplicant form={form} />

              </div>
            }
            {tabStep === 1 &&
              <>
                <EvidencePayment form={form} />
              </>
            }
            <ContainerButton
              sxContainer={{ my: 3 }}
              buttonData={[
                {
                  seq: 1,
                  buttonProps: {
                    onClick: () => { navigate(-1) },
                  },
                  key: "CANCEL",
                  label: t("LIST_APPLICANTS_BACK"),
                  type: "CANCEL"
                },
                {
                  seq: 2,
                  buttonProps: {
                    onClick: () => {
                      setShowModal('REJECT')
                    }
                  },
                  key: "REJECT",
                  label: t("LIST_APPLICANTS_NOT_APPROVED"),
                  type: "REJECT",
                  hidden: !checkPermit?.isUpdate && form?.admission_status !== ADMISSION_STATUS.WAITING_FOR_VERIFICATION
                },
                {
                  seq: 3,
                  buttonProps: {
                    onClick: () => {
                      // alertActive(t("LIST_APPLICANTS_APPROVED"), t("LIST_APPLICANTS_CONFIRM_DECISION"), undefined, undefined, async () => {
                      //   handleVerified()
                      // })
                      setShowModal('SUCCESS')
                    }
                  },
                  key: "APPROVE",
                  label: t("LIST_APPLICANTS_APPROVED_WAITING_EXAM"),
                  type: "APPROVE",
                  hidden: !checkPermit?.isUpdate && form?.admission_status !== ADMISSION_STATUS.WAITING_FOR_VERIFICATION

                },
              ]}
            />
          </div>
        }
      />
      {showModal === 'REJECT' && (
        <ModalCustom
          open
          title={t('LIST_APPLICANTS_UPDATE_STATUS')}
          subTitle={t("LIST_APPLICANTS_CONFIRM_UPDATE_WAITING_EXAM")}
          // maxWidth={600}
          onClose={handleCloseModal}
          containerButton={{
            disabled_submit: !des,
            // hidden_submit: showModal === 'VIEW',
            onClose: handleCloseModal,
            onSubmit: () => { handleReject() }
          }}
          component={
            <div className='w-full'>
              <StateComponents
                otherProps={{ spacing: 2 }}
                typeProps={[
                  {
                    seq: 6,
                    type: "TEXT_FIELD",
                    gridProps: {
                      xs: 12,
                      // md: 6
                    },
                    fieldProps: {
                      heading: t("LIST_APPLICANTS_REMARK"),
                      onChange: (e) => {
                        setDes(e.target.value)
                      },
                      value: des || '',
                      minRow: 6,
                      multiline: true,
                      inputHeight: 'auto'
                    }
                  },
                ]} />
            </div>
          }
        />
      )}

      {showModal === 'SUCCESS' && (
        <ModalCustom
          open
          title={t("LIST_APPLICANTS_APPROVED")}
          subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน")}
          // maxWidth={600}
          onClose={handleCloseModal}
          containerButton={{
            // disabled_submit: !form.gallery_type_name,
            // hidden_submit: showModal === 'VIEW',
            onClose: handleCloseModal,
            onSubmit: () => { handleAPPROVE() }
          }}
          component={
            <div className='w-full'>
              <Box sx={{
                // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                padding: "10px 20px",
                borderRadius: "20px",
                // height: "500px",
                border: '1px solid #DDE1EB',
                cursor: 'pointer'
              }}>
                {file ?
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                    <div>
                      <Typography sx={{ fontSize: '16px' }}>{file?.name}</Typography>
                      <Typography>{formatBytes(file?.size)}</Typography>
                    </div>
                    <ButtonContained buttonName='ลบไฟล์' onClick={() => {
                      setFile(null)
                      if (fileRef.current) {
                        fileRef.current.value = null;
                      }
                    }} />

                  </div>
                  : <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                    <div>
                      <Typography sx={{ fontSize: '16px' }}>{'เลือกไฟล์'}</Typography>
                      {/* <Typography>{formatBytes(file?.size)}</Typography> */}
                    </div>
                    <ButtonContained buttonName='เลือกไฟล์' onClick={() => { fileRef.current.click() }} />
                  </div>}

              </Box>
              <input ref={fileRef} className='hidden' type='file'
                accept={"image/*"}
                onChange={(e: any) => {
                  setFile(e.target.files[0])
                  if (fileRef.current) {
                    fileRef.current.value = null;
                  }
                }} />
            </div>
          }
        />
      )}
    </div>
  )
}

export const FormApplicant = (props: any) => {
  const { form } = props
  return (
    <StateComponents
      otherProps={{ spacing: 2 }}
      typeProps={[
        {
          seq: 1,
          type: "SELECT",
          gridProps: {
            xs: 12,
            md: 2
          },
          fieldProps: {
            labelId: "ss",
            heading: "Title",
            onChange: (e) => {
              // handleChange('form_type', index, e.target.value);
            },
            options: [
              {
                label: "Mr.",
                value: 'Mr.',
              },
              {
                label: "Ms.",
                value: 'Ms.',
              },

            ],
            selectId: "",
            value: form?.title || '',
            disabled: true,
          }
        },
        {
          seq: 2,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 5
          },
          fieldProps: {
            heading: "Name",
            onChange: (e) => { },
            disabled: true,
            value: form?.first_name || ''
          }
        },
        {
          seq: 3,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 5
          },
          fieldProps: {
            heading: "Last Name",
            onChange: (e) => { },
            disabled: true,
            value: form?.last_name || ''
          }
        },
        {
          seq: 4,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "Middle-Name or Buddhist Name (If doesn't have just leave it blank)",
            onChange: (e) => { },
            disabled: true,
            value: form?.middle_name || ''
          }
        },
        {
          seq: 5,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Phone Number",
            onChange: (e) => { },
            disabled: true,
            value: form?.phone || ''
          }
        },
        {
          seq: 6,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "E-mail",
            onChange: (e) => { },
            disabled: true,
            value: form?.email || ''
          }
        },
        {
          type: "COMPONENT",
          seq: 7,
          fieldProps: {
            element: <Divider />
          },
          gridProps: {
            xs: 12,
          }
        },
        {
          seq: 8,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "Educational level",
            onChange: (e) => { },
            disabled: true,
            value: form?.english_qualification
          }
        },
        {
          seq: 9,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "Name of the Institute",
            onChange: (e) => { },
            disabled: true,
            value: form?.name_of_institue
          }
        },
        {
          seq: 10,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "Year of graduated",
            onChange: (e) => { },
            disabled: true,
            value: form?.year_graduated
          }
        },
        {
          seq: 11,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "GPA",
            onChange: (e) => { },
            disabled: true,
            value: form?.gpa
          }
        },
        {
          seq: 12,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "My Dhamma Qualifications",
            onChange: (e) => { },
            disabled: true,
            value: form?.dhamma_qualification
          }
        },
        {
          seq: 13,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "English Qualification",
            onChange: (e) => { },
            disabled: true,
            value: form?.english_qualification
          }
        },
        {
          type: "COMPONENT",
          seq: 14,
          fieldProps: {
            element: <Typography>Apply For :</Typography>
          },
          gridProps: {
            xs: 12,
          }
        },
        {
          seq: 15,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Academic Year",
            onChange: (e) => { },
            disabled: true,
            value: form?.academic_year?.academic_year || ''
          }
        },
        {
          seq: 16,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Degree",
            onChange: (e) => { },
            disabled: true,
            value: `${form?.degree?.degree_name_eng} (${form?.degree?.degree_name})`
          }
        },
        {
          seq: 17,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Faculty",
            onChange: (e) => { },
            disabled: true,
            value: `${form?.faculty?.faculty_name_eng} (${form?.faculty?.faculty_name})`
          }
        },
        // {
        //   seq: 15,
        //   type: "SELECT",
        //   gridProps: {
        //     xs: 12,
        //     md: 6
        //   },
        //   fieldProps: {
        //     labelId: "ss",
        //     heading: "Degree",
        //     onChange: (e) => {
        //       // handleChange('form_type', index, e.target.value);
        //     },
        //     options: [
        //       {
        //         label: "BA",
        //         value: 'BA',
        //       },

        //     ],
        //     selectId: "",
        //     value: 'BA'
        //   }
        // },
        // {
        //   seq: 16,
        //   type: "SELECT",
        //   gridProps: {
        //     xs: 12,
        //     md: 6
        //   },
        //   fieldProps: {
        //     labelId: "ss",
        //     heading: "Faculty",
        //     onChange: (e) => {
        //       // handleChange('form_type', index, e.target.value);
        //     },
        //     options: [
        //       {
        //         label: "Buddhist Studies",
        //         value: 'Buddhist Studies',
        //       },

        //     ],
        //     selectId: "",
        //     value: 'Buddhist Studies'
        //   }
        // },
        {
          type: "COMPONENT",
          seq: 17.5,
          fieldProps: {
            element: <Divider />
          },
          gridProps: {
            xs: 12,
          }
        },
        {
          type: "COMPONENT",
          seq: 18,
          fieldProps: {
            element: <Typography variant="h4">Personal Information</Typography>
          },
          gridProps: {
            xs: 12,
          }
        },
        {
          seq: 19,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Passport number (Foreigner)/ID Card Number (Thai)",
            onChange: (e) => { },
            disabled: true,
            value: form?.idcard || ''
          }
        },

        {
          seq: 20,
          type: "DATE",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            onChange: (e) => { },
            heading: '(Passport) Date of issue',
            placeholder: '(Passport) Date of issue',
            allowClear: true,
            onClear: () => {

            },
            disabled: true,
            value: form?.date_of_issue || ''
          }
        },
        {
          seq: 21,
          type: "DATE",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            onChange: (e) => { },
            heading: '(Passport) Date of expiry',
            placeholder: '(Passport) Date of expiry',
            allowClear: true,
            onClear: () => {

            },
            disabled: true,
            value: form?.date_of_expiry || ''
          }
        },
        {
          seq: 22,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 1
          },
          fieldProps: {
            heading: "Weight (kg.)",
            onChange: (e) => { },
            disabled: true,
            value: form?.weight || ''
          }
        },
        {
          seq: 23,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 1
          },
          fieldProps: {
            heading: "Height (cm.)",
            onChange: (e) => { },
            disabled: true,
            value: form?.height || ''
          }
        },
        {
          seq: 24,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 1
          },
          fieldProps: {
            heading: "Blood Type",
            onChange: (e) => { },
            disabled: true,
            value: form?.blood || ''
          }
        },
        {
          seq: 25,
          type: "DATE",
          gridProps: {
            xs: 12,
            md: 2
          },
          fieldProps: {
            onChange: (e) => { },
            heading: 'Date of Birth',
            placeholder: 'Date of Birth',
            allowClear: true,
            onClear: () => {

            },
            disabled: true,
            value: form?.date_of_birth,
          }

        },
        {
          seq: 26,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 5
          },
          fieldProps: {
            heading: "Place of Birth",
            onChange: (e) => { },
            disabled: true,
            value: form?.place_of_birth,
          }
        },
        {
          seq: 27,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 2
          },
          fieldProps: {
            heading: "Race/Ethnic",
            onChange: (e) => { },
            disabled: true,
            value: form?.race,
          }
        },
        {
          seq: 28,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Nationality",
            onChange: (e) => { },
            disabled: true,
            value: form?.nationality,
          }
        },
        {
          seq: 29,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Religion",
            onChange: (e) => { },
            disabled: true,
            value: form?.religion,
          }
        },
        {
          seq: 30,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Occupation",
            onChange: (e) => { },
            disabled: true,
            value: form?.occupation,
          }
        },
        {
          seq: 31,
          type: "DATE",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            onChange: (e) => { },
            heading: 'Date of Ordination (laypeople please skip this )',
            placeholder: 'Date of Ordination (laypeople please skip this )',
            allowClear: true,
            onClear: () => {

            },
            disabled: true,
            value: form?.ordination_date,
          }

        },
        {
          seq: 32,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Sect (laypeople please skip this )",
            onChange: (e) => { },
            disabled: true,
            value: form?.sect,
          }
        },
        {
          seq: 33,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Disability",
            onChange: (e) => { },
            disabled: true,
            value: form?.dissability,
          }
        },
        {
          seq: 34,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Number of sibling",
            onChange: (e) => { },
            disabled: true,
            value: form?.number_of_sibling,
          }
        },
        {
          seq: 35,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Number of sibling whom still study",
            onChange: (e) => { },
            disabled: true,
            value: form?.number_of_sibling_still_study,
          }
        },
        {
          seq: 36,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Skills/Interests",
            onChange: (e) => { },
            disabled: true,
            value: form?.skill,
          }
        },
        {
          type: "COMPONENT",
          seq: 37,
          fieldProps: {
            element: <Divider />
          },
          gridProps: {
            xs: 12,
          }
        },
        {
          type: "COMPONENT",
          seq: 38,
          fieldProps: {
            element: <Typography variant="h4">Address</Typography>
          },
          gridProps: {
            xs: 12,
          }
        },
        {
          seq: 39,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "Name of the Temple (laypeople please skip this section)",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x?.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.name_of_temple
          }
        },
        {
          seq: 40,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "Name of the Abbot (laypeople please skip this section)",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.name_of_abbot
          }
        },
        {
          seq: 41,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "House No.",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.house_no
          }
        },
        {
          seq: 42,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Street / Road",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.street
          }
        },
        {
          seq: 43,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Village",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.village
          }
        },
        {
          seq: 44,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Town / City",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.town
          }
        },
        {
          seq: 45,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Province",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.province
          }
        },
        {
          seq: 45.5,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "District",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.district
          }
        },
        {
          seq: 46,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "State",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.district_sub
          }
        },
        {
          seq: 47,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Country",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.country
          }
        },
        {
          seq: 48,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Postal/Zip Code",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.postcode
          }
        },
        {
          type: "COMPONENT",
          seq: 48.1,
          fieldProps: {
            element: <Typography variant="h4">Current Address</Typography>
          },
          gridProps: {
            xs: 12,
          }
        },
        {
          seq: 48.2,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "Name of the Temple (laypeople please skip this section)",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.name_of_temple
          }
        },
        {
          seq: 48.3,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 6
          },
          fieldProps: {
            heading: "Name of the Abbot (laypeople please skip this section)",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.name_of_abbot
          }
        },
        {
          seq: 48.4,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "House No.",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.house_no
          }
        },
        {
          seq: 48.5,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Street / Road",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.street
          }
        },
        {
          seq: 48.6,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Village",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.village
          }
        },
        {
          seq: 48.7,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Town / City",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.town
          }
        },
        {
          seq: 48.8,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Province",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.province
          }
        },
        {
          seq: 48.81,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "District",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.district
          }
        },
        {
          seq: 48.82,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "State",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.district_sub
          }
        },
        {
          seq: 48.83,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Country",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.country
          }
        },
        {
          seq: 48.84,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Postal/Zip Code",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.postcode
          }
        },
        {
          type: "COMPONENT",
          seq: 49,
          fieldProps: {
            element: <Divider />
          },
          gridProps: {
            xs: 12,
          }
        },
        {
          type: "COMPONENT",
          seq: 50,
          fieldProps: {
            element: <Typography variant="h4">Parent</Typography>
          },
          gridProps: {
            xs: 12,
          }
        },
        {
          seq: 51,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Father's name",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.father_name,

          }
        },
        {
          seq: 52,
          type: "SELECT",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            labelId: "ss",
            heading: "Father's status",
            onChange: (e) => {
              // handleChange('form_type', index, e.target.value);
            },
            options: [
              {
                label: "Alived",
                value: 'ALIVED',
              },
              {
                label: "Died",
                value: 'DIED  ',
              },

            ],
            selectId: "",
            disabled: true,
            value: form?.admission_student_parent?.father_status || '',
          }
        },
        {
          seq: 53,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Father's occupation",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.father_occupation,
          }
        },
        {
          seq: 54,
          type: "SELECT",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            labelId: "ss",
            heading: "Father's income per year",
            onChange: (e) => {
              // handleChange('form_type', index, e.target.value);
            },
            options: [
              {
                label: "0-50k (THB)",
                value: '0-50k (THB)',
              },
              {
                label: "50k-100k (THB)",
                value: '50k-100k (THB)',
              },
              {
                label: "100k Up (THB)",
                value: '100k Up (THB)',
              },

            ],
            selectId: "",
            disabled: true,
            value: form?.admission_student_parent?.father_income || '',
          }
        },
        {
          seq: 55,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Mother's name",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.mother_name,
          }
        },
        {
          seq: 56,
          type: "SELECT",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            labelId: "ss",
            heading: "Mother's status",
            onChange: (e) => {
              // handleChange('form_type', index, e.target.value);
            },
            options: [
              {
                label: "Alived",
                value: 'ALIVED',
              },
              {
                label: "Died",
                value: 'DIED  ',
              },

            ],
            selectId: "",
            disabled: true,
            value: form?.admission_student_parent?.mother_status || '',
          }
        },
        {
          seq: 57,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Mother's occupation",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.mother_occupation,
          }
        },
        {
          seq: 58,
          type: "SELECT",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            labelId: "ss",
            heading: "Mother's income per year",
            onChange: (e) => {
              // handleChange('form_type', index, e.target.value);
            },
            options: [
              {
                label: "0-50k (THB)",
                value: '0-50k (THB)',
              },
              {
                label: "50k-100k (THB)",
                value: '50k-100k (THB)',
              },
              {
                label: "100k Up (THB)",
                value: '100k Up (THB)',
              },
            ],
            selectId: "",
            disabled: true,
            value: form?.admission_student_parent?.mother_income || '',
          }
        },
        {
          seq: 59,
          type: "SELECT",
          gridProps: {
            xs: 12,
          },
          fieldProps: {
            labelId: "ss",
            heading: "Parent's marriage status",
            onChange: (e) => {
              // handleChange('form_type', index, e.target.value);
            },
            options: [
              {
                label: "stay together",
                value: 'STAY_TOGETHER',
              },
              {
                label: "Divorce",
                value: 'DIVORCE',
              },

            ],
            selectId: "",
            disabled: true,
            value: form?.admission_student_parent?.parent_marriage || '',
          }
        },
        {
          seq: 60,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Referent person's name",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_name,
          }
        },
        {
          seq: 61,
          type: "SELECT",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            labelId: "ss",
            heading: "Relationship",
            onChange: (e) => {
              // handleChange('form_type', index, e.target.value);

            },
            options: [
              {
                label: "Father",
                value: 'FATHER',
              },
              {
                label: "Mother",
                value: 'MOTHER',
              },
              {
                label: "Other",
                value: 'OTHER ',
              },

            ],
            selectId: "",
            disabled: true,
            value: form?.admission_student_parent?.refperson_relationship || '',
          }
        },
        {
          seq: 62,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Referent person's occupation",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_occupation || '',
          }
        },

        {
          seq: 63,
          type: "SELECT",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            labelId: "ss",
            heading: "Referent person's income per year",
            onChange: (e) => {
              // handleChange('form_type', index, e.target.value);
            },
            options: [
              {
                label: "0-50k (THB)",
                value: '0-50k (THB)',
              },
              {
                label: "50k-100k (THB)",
                value: '50k-100k (THB)',
              },
              {
                label: "100k Up (THB)",
                value: '100k Up (THB)',
              },

            ],
            selectId: "",
            disabled: true,
            value: form?.admission_student_parent?.refperson_income || '',
          }
        },
        {
          seq: 64,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "House No.",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_house || '',
          }
        },
        {
          seq: 65,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Street / Road",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_street || '',
          }
        },
        {
          seq: 66,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Village",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_vilage || '',
          }
        },
        {
          seq: 67,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Town / City",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_town || '',
          }
        },

        {
          seq: 68,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Province",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_province || '',
          }
        },
        {
          seq: 69,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "District",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_district || '',
          }
        },
        {
          seq: 70,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "State",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_district_sub || '',
          }
        },
        {
          seq: 71,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 3
          },
          fieldProps: {
            heading: "Country",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_country || '',
          }
        },
        {
          seq: 72,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Postal/Zip Code",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_postcode || '',
          }
        },
        {
          seq: 73,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "Phone No.",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_phone,
          }
        },
        {
          seq: 74,
          type: "TEXT_FIELD",
          gridProps: {
            xs: 12,
            md: 4
          },
          fieldProps: {
            heading: "E-mail",
            onChange: (e) => { },
            disabled: true,
            value: form?.admission_student_parent?.refperson_email,
          }
        },
        {
          type: "COMPONENT",
          seq: 75,
          fieldProps: {
            element: <Divider />
          },
          gridProps: {
            xs: 12,
          }
        },
      ]}
    />
  )
}
export const FileApplicant = (props: any) => {
  const { form } = props
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [pathUrl, setPathUrl] = useState<string>("");
  useEffect(() => {
    const init = async () => {
      const response = await fetch("/resources/config.json");
      const results = await response.json();
      setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
    };
    init();
  }, []);

  const handleDownloadFile = async () => {
    dispatch(setLoading());

    await AdmissionFrontApi.downloadFileZip(form?.id_admission_student)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          // Generate a filename with the correct extension (you can also modify this to use a custom name)
          const fileName = `${"report-advisor" + new Date().getTime()
            }.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };
  function formatBytes(bytes: any, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }
  return (
    <Box sx={{
      border: '1px solid #DDE1EB',
      borderRadius: '18px', overflow: 'hidden'
    }}>
      <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
        <ContainerButton
          justifyContent='flex-end'
          buttonData={[
            {
              buttonProps: {
                onClick: () => { handleDownloadFile() }
              },
              key: "DOWNLOAD_CSV",
              label: t('LIST_APPLICANTS_DOWNLOAD_ALL'),
              seq: 1,
              type: "DOWNLOAD_CSV"
            }
          ]}
        />
      </Box>
      <Box sx={{ padding: '10px' }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: '10px' }}>
          {form?.admission_student_files?.map((item: any) => {
            return (
              <Box sx={{
                padding: '10px 15px', border: '1px solid #DDE1EB',
                borderRadius: '8px',
                display: "flex", justifyContent: 'space-between'
              }}>
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <Typography sx={{ whiteSpace: "nowrap" }}>{item?.document?.document_name}<span style={{ color: "red", marginLeft: '10px' }}>{item?.document?.is_require === 1 ? '*' : ''}</span></Typography>
                  </Box>
                  <Typography>{item?.file_name} {formatBytes(item?.file_size)}</Typography>
                </Box>
                <OptionsButtonCustom
                  // enableEdit
                  enableView
                  onViewClick={() => { window.open(pathUrl + '/' + item?.file_path + item?.file_name, '_blank') }}
                // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}

                />

              </Box>
            )
          })}
        </Box>

      </Box>

    </Box>
  )
}

export const EvidencePayment = (props: any) => {
  const { form } = props
  const { t } = useTranslation();

  const [type, setType] = useState<string>('THB')

  const [pathUrl, setPathUrl] = useState<string>("");
  useEffect(() => {
    const init = async () => {
      const response = await fetch("/resources/config.json");
      const results = await response.json();
      setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
    };
    init();
  }, []);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <Box sx={{
        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        padding: "20px",
        borderRadius: "20px",
        display: "flex",
        flexDirection: 'column',
        gap: '10px'
      }}>
        <Box sx={{
          display: 'flex', alignItems: 'center', gap: "10px"
        }}>
          {/* <Typography sx={{ color: '#737373' }}>ชื่อบัญชี <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_register?.account_name_th}</span></Typography> */}
          <Typography sx={{ color: '#737373' }}>Account Name <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_register?.account_name_eng}</span></Typography>
          <Typography sx={{ color: '#737373' }}>Account No. <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_register?.account_no}</span></Typography>
          <Typography sx={{ color: '#737373' }}>Account Type <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_register?.account_type}</span></Typography>
        </Box>
        <Box sx={{ background: '#4A4A4A', padding: '10px', display: 'flex', alignItems: 'center', gap: "10px", borderRadius: '18px' }}>
          <Typography sx={{ color: '#fff' }}>Currency</Typography>
          <StateComponents
            otherProps={{ spacing: 2 }}
            typeProps={[

              {
                seq: 1,
                type: "SELECT",
                gridProps: {
                  xs: 12,
                },
                fieldProps: {
                  labelId: "ss",
                  // heading: "สกุลเงิน",
                  onChange: (e) => {
                    setType(e.target.value)
                    // handleChange('form_type', index, e.target.value);
                  },
                  options: [
                    {
                      label: "THB",
                      value: 'THB',
                    },
                    {
                      label: "USD",
                      value: 'USD',
                    },
                  ],
                  selectId: "",
                  value: type || ''
                }
              },


            ]} />
          <Typography sx={{ color: '#fff' }}>Bachelor of arts degree : Application fee {type === 'THB' ? `${form?.course_of_study?.price_bath} Thai Baht (THB)` : `${form?.course_of_study?.price_usd} United States dollar (USD)`}</Typography>
        </Box>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={form?.admission_student_register_payment?.file_path_approve ? 6 : 12}>
          <Box sx={{
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
            padding: "10px",
            borderRadius: "20px",
            height: "500px",
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img src={pathUrl + '/' + form?.admission_student_register_payment?.file_path + form?.admission_student_register_payment?.file_name} style={{ width: '100%', maxHeight: '450px', objectFit: 'contain' }} />
          </Box>
        </Grid>
        {form?.admission_student_register_payment?.file_path_approve && <Grid item xs={12} md={6}>
          <Box sx={{
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
            padding: "10px",
            borderRadius: "20px",
            height: "500px",
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img src={pathUrl + '/' + form?.admission_student_register_payment?.file_path_approve + form?.admission_student_register_payment?.file_name_approve} style={{ width: '100%', maxHeight: '450px', objectFit: 'contain' }} />
          </Box>
        </Grid>}
      </Grid>

      <StateComponents
        otherProps={{ spacing: 2 }}
        typeProps={[
          {
            seq: 1,
            type: "DATE",
            gridProps: {
              xs: 12,
              md: 3
            },
            fieldProps: {
              onChange: (e) => { },
              heading: t('Payment Date'),
              placeholder: t('Payment Date'),
              // heading: t('LIST_APPLICANTS_PAYMENT_DATE'),
              // placeholder: t('LIST_APPLICANTS_PAYMENT_DATE'),
              allowClear: true,
              onClear: () => {

              },
              disabled: true,
              value: form?.admission_student_register_payment?.payment_date || '',
            },
          },
          {
            seq: 2,
            type: "TEXT_FIELD",
            gridProps: {
              xs: 12,
              md: 3
            },
            fieldProps: {
              heading: t("Payment Time"),
              // heading: t("LIST_APPLICANTS_PAYMENT_TIME"),
              onChange: (e) => { },
              type: 'time',
              disabled: true,
              value: timeToView(form?.admission_student_register_payment?.payment_date),
            }
          },
          {
            seq: 3,
            type: "SELECT",
            gridProps: {
              xs: 12,
              md: 1.5
            },
            fieldProps: {
              labelId: "ss",
              heading: t("Currency"),
              // heading: t("LIST_APPLICANTS_PAYMENT_CURRENCY"),
              onChange: (e) => {
                // handleChange('form_type', index, e.target.value);
              },
              options: [
                {
                  label: "THB",
                  value: 'THB',
                },
                {
                  label: "USD",
                  value: 'USD',
                },

              ],
              selectId: "",
              disabled: true,
              value: form?.admission_student_register_payment?.payment_currency || '',
            }
          },
          {
            seq: 4,
            type: "TEXT_FIELD",
            gridProps: {
              xs: 12,
              md: 3
            },
            fieldProps: {
              heading: t("Amount"),
              // heading: t("LIST_APPLICANTS_PAYMENT_AMOUNT"),
              onChange: (e) => { },
              disabled: true,
              value: form?.admission_student_register_payment?.payment_amount,
            }
          },
          {
            seq: 5,
            type: "TEXT_FIELD",
            gridProps: {
              xs: 12,
              md: 1.5
            },
            fieldProps: {
              heading: t("Type"),
              // heading: t("LIST_APPLICANTS_PAYMENT_PROOF_TYPE"),
              onChange: (e) => { },
              disabled: true,
              value: form?.admission_student_register_payment?.payment_type || 'ATTACH_SLIP',
            }
          },
        ]} />
    </Box>
  )
}

export const TermPayment = (props: any) => {
  const { form } = props
  // const [type, setType] = useState<string>('THB')
  const { t } = useTranslation();

  const [pathUrl, setPathUrl] = useState<string>("");
  useEffect(() => {
    const init = async () => {
      const response = await fetch("/resources/config.json");
      const results = await response.json();
      setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
    };
    init();
  }, []);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <Box sx={{
        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        padding: "20px",
        borderRadius: "20px",
        display: "flex",
        flexDirection: 'column',
        gap: '10px'
      }}>
        {/* <Box sx={{
          display: 'flex', alignItems: 'center', gap: "10px"
        }}>
          <Typography sx={{ color: '#737373' }}>ชื่อบัญชี <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_name_th}</span></Typography>
          <Typography sx={{ color: '#737373' }}>Account Name <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_name_eng}</span></Typography>
          <Typography sx={{ color: '#737373' }}>เลขที่บัญชี Account No. <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_no}</span></Typography>
          <Typography sx={{ color: '#737373' }}>Account Type <span style={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_type}</span></Typography>
        </Box>
        <Box sx={{ background: '#4A4A4A', padding: '10px', display: 'flex', alignItems: 'center', gap: "10px", borderRadius: '18px' }}>
          <Typography sx={{ color: '#fff' }}>Currency</Typography>
          <StateComponents
            otherProps={{ spacing: 2 }}
            typeProps={[

              {
                seq: 1,
                type: "SELECT",
                gridProps: {
                  xs: 12,
                },
                fieldProps: {
                  labelId: "ss",
                  // heading: "สกุลเงิน",
                  onChange: (e) => {
                    setType(e.target.value)
                    // handleChange('form_type', index, e.target.value);
                  },
                  options: [
                    {
                      label: "THB",
                      value: 'THB',
                    },
                    {
                      label: "USD",
                      value: 'USD',
                    },
                  ],
                  selectId: "",
                  value: type || ''
                }
              },


            ]} />
          <Typography sx={{ color: '#fff' }}>Bachelor of arts degree : Application fee {type === 'THB' ? `${form?.course_of_study?.price_bath} Thai Baht (THB)` : `${form?.course_of_study?.price_usd} United States dollar (USD)`}</Typography>
        </Box> */}
        <Box sx={{
          // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
          // padding: "40px",
          // borderRadius: "20px",
          display: "flex",
          flexDirection: 'column',
          gap: '10px'
        }}>
          <Typography sx={{ fontWeight: "600" }}>Student ID:: {form?.student?.student_no}</Typography>
          <Typography sx={{ fontWeight: "600" }}>Payment link: <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => window.open(form?.url_payment_term, '_blank')}>{form?.url_payment_term}</span></Typography>
          {/* <Typography sx={{ fontWeight: "600", fontSize: '24px' }}>คู่มือการชำระเงิน</Typography> */}

        </Box>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={form?.admission_student_term_payment?.file_path_approve ? 6 : 12}>
          <Box sx={{
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
            padding: "10px",
            borderRadius: "20px",
            height: "500px",
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img src={pathUrl + '/' + form?.admission_student_term_payment?.file_path + form?.admission_student_term_payment?.file_name} style={{ width: '100%', maxHeight: '450px', objectFit: 'contain' }} />
          </Box>
        </Grid>
        {form?.admission_student_term_payment?.file_path_approve && <Grid item xs={12} md={6}>
          <Box sx={{
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
            padding: "10px",
            borderRadius: "20px",
            height: "500px",
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img src={pathUrl + '/' + form?.admission_student_term_payment?.file_path_approve + form?.admission_student_term_payment?.file_name_approve} style={{ width: '100%', maxHeight: '450px', objectFit: 'contain' }} />
          </Box>
        </Grid>}
      </Grid>
      {/* <Box sx={{
        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        padding: "10px",
        borderRadius: "20px",
        height: "500px",
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <img src={pathUrl + '/' + form?.admission_student_term_payment?.file_path + form?.admission_student_term_payment?.file_name} style={{ width: '100%', maxHeight: '450px', objectFit: 'contain' }} />
      </Box> */}
      {/* <StateComponents
        otherProps={{ spacing: 2 }}
        typeProps={[
          {
            seq: 1,
            type: "DATE",
            gridProps: {
              xs: 12,
              md: 3
            },
            fieldProps: {
              onChange: (e) => { },
              heading: 'วันที่ชำระเงิน',
              placeholder: 'วันที่ชำระเงิน',
              allowClear: true,
              onClear: () => {

              },
              disabled: true,
              value: form?.admission_student_term_payment?.payment_date,
            },
          },
          {
            seq: 2,
            type: "TEXT_FIELD",
            gridProps: {
              xs: 12,
              md: 3
            },
            fieldProps: {
              heading: "เวลาชำระเงิน",
              onChange: (e) => { },
              type: 'time',
              disabled: true,
              value: timeToView(form?.admission_student_term_payment?.payment_date),
            }
          },
          {
            seq: 3,
            type: "SELECT",
            gridProps: {
              xs: 12,
              md: 1.5
            },
            fieldProps: {
              labelId: "ss",
              heading: "สกุลเงิน",
              onChange: (e) => {
                // handleChange('form_type', index, e.target.value);
              },
              options: [
                {
                  label: "THB",
                  value: 'THB',
                },

              ],
              selectId: "",
              disabled: true,
              value: form?.admission_student_term_payment?.payment_currency,
            }
          },
          {
            seq: 4,
            type: "TEXT_FIELD",
            gridProps: {
              xs: 12,
              md: 3
            },
            fieldProps: {
              heading: "จำนวนยอดเงิน",
              onChange: (e) => { },
              disabled: true,
              value: form?.admission_student_term_payment?.payment_amount,
            }
          },
          {
            seq: 5,
            type: "TEXT_FIELD",
            gridProps: {
              xs: 12,
              md: 1.5
            },
            fieldProps: {
              heading: "ประเภทหลักฐาน",
              onChange: (e) => { },
              disabled: true,
              value: form?.admission_student_term_payment?.payment_type || 'ATTACH_SLIP',
            }
          },
        ]} /> */}
    </Box>
  )
}